import { AppDate } from '../envTypes';

export enum TinStatus {
  NotStart = 'NotStart',
  Accepted = 'Accepted',
  Blocked = 'Blocked',
  Processing = 'Processing',
  Rejected = 'Rejected',
}

export enum FormW9Status {
  NotStart = 'NotStart',
  Pending = 'Pending',
  Completed = 'Completed',
  Expired = 'Expired',
}

export interface SellerFormW9 {
  sellerId: string;
  clientRecipientId: string;
  formW9Url?: string;
  formW9CreatedAt?: AppDate;
  formW9ExpiredAt?: AppDate;
  formW9CompletedAt?: AppDate;
  formW9Status: FormW9Status;
  tinMatchRequestId?: number;
  tinStatus: TinStatus;
  tinReason?: string;
  createdAt: AppDate;
  updatedAt: AppDate;
}

export interface SellerFormW9Webhook {
  callbackUID: string;
  sellerId: string;
  type: 'FormW9';
}
